module.exports = __webpack_public_path__ + "static/media/turning-red-logo@2x.b83db210.png";